import { usesLanguages } from '@trello/locale';

export const templateUrlSlug = (
  category: string,
  name: string,
  shortLink: string,
) => {
  return `${category}/${(name || '')
    .replace(/\s+/g, '-')
    .toLowerCase()}-${shortLink}`;
};

const templateGalleryLanguages = ['en', 'fr', 'pt-BR'];

export const showGalleryLocalization = (
  templateGalleryLocalizationFeatureFlag: boolean,
) => {
  return (
    usesLanguages(templateGalleryLanguages) &&
    templateGalleryLocalizationFeatureFlag
  );
};

export const submitTemplateUrls = (
  locale: string,
  simpleTypeform: boolean = false,
) => {
  if (locale === 'fr') {
    return 'https://trello.typeform.com/to/e2fpuF';
  } else if (locale === 'pt-BR') {
    return 'https://trello.typeform.com/to/so0XYj';
  } else if (simpleTypeform) {
    return 'https://trello.typeform.com/to/s67e0q'; // simpler English typeform
  } else {
    return 'https://trello.typeform.com/to/YxMGeV'; // more complex English typeform
  }
};

export const Helpers = {
  templateUrlSlug,
  showGalleryLocalization,
  submitTemplateUrls,
};
